import cn from 'classnames';

import { CustomLink } from '../link';
import { Text, TextProps } from '.';
import mc from './text.module.css';

export const markdownComponents = {
  a: CustomLink,
  h1: (props: TextProps) => <Text variant="h1" className="mb-2" {...props} />,
  h2: (props: TextProps) => <Text variant="h2" className="mb-2" {...props} />,
  h3: (props: TextProps) => <Text variant="h3" className="mb-2" {...props} />,
  h4: (props: TextProps) => <Text variant="h4" className="mb-2" {...props} />,
  h5: (props: TextProps) => <Text variant="h5" className="mb-2" {...props} />,
  h6: (props: TextProps) => <Text variant="h6" className="mb-2" {...props} />,
  ol: (props: TextProps) => <ol className={mc.ol} {...props} />,
  ul: (props: TextProps) => <ul className={mc.ul} {...props} />,
  li: 'li',
  table: (props: TextProps) => (
    <div className="overflow-x-auto">
      <table className={mc.table} {...props} />
    </div>
  ),
  p: (props: TextProps) => <p className={cn(mc.body, 'mb-4')} {...props} />,
};
